// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__MV51f","header":"style_header__qpxka","grid":"style_grid__WBjbf"};